<template>
  <div class="view-message">
    <div class="view-message__wrapper">
      <div class="view-message__header">
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1 m0">{{ getSelectedMessage.subject }}</h1>
        <p class="p small c-accent">From {{ getSelectedMessage.from }}</p>
        <p class="p small c-accent tar">{{ date }}</p>
      </div>
      <div class="view-message__message">
        <p v-for="(line, key) in formattedMessage" :key="key" class="p">
          {{ line }}
        </p>
      </div>
      <module-button
        v-if="receivedMessage && canReply"
        label="Reply"
        button="primary"
        @click.native="replyToMessage"
      />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// 3rd party
import moment from 'moment';


export default {
  name: 'view-message',

  // Data
  computed: {
    ...mapGetters('messaging', ['getSelectedMessage', 'getAllContacts']),
    ...mapGetters('app', ['org']),

    date() {
      return moment(this.getSelectedMessage.date_time).format('ddd, MMM Do, H:mma') ;
    },
    receivedMessage() {
      return JSON.parse(localStorage.getItem('updateUser')).mdlive_id !== this.getSelectedMessage.from_id;
    },
    canReply() {
      return this.getSelectedMessage.reply_allowed;
    },
    formattedMessage() {
      return this.getSelectedMessage.message ? this.getSelectedMessage.message.split('\n') : '';
    },
  },

  methods: {
    ...mapActions('messaging', ['requestMessageById', 'requestContactById', 'requestUnreadCount', 'requestAllMessages']),

    replyToMessage() {
      this.requestContactById(localStorage.getItem('contactID'));
      localStorage.setItem('messageSubject', this.getSelectedMessage.subject);
      this.$router.push('/messages/compose');
    },

  },

  created() {
    this.requestMessageById(localStorage.getItem('messageID'));

    if (localStorage.getItem('contactID')) {
      this.requestContactById(localStorage.getItem('contactID'));
    }
    setTimeout(() => {
      this.requestUnreadCount();
    }, 1500);
  },
};
</script>



// WEBPACK FOOTER //
// ViewMessage.vue?d3948398